import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
// import moment from 'moment';
import { addMinutes, getMinutes, getHours, parse } from 'date-fns';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

import Input from '../../components/Input/Input';
import { createVacations, updateVacations } from '../../store/actions/vacation';

const styles = () => ({
  paperWidth: {
    padding: '10px 0',
    width: '750px',
    maxWidth: '750px',
  },
});

export class AllowanceEditDialog extends React.Component {
  state = {
    vacation: {
      dtFrom: '',
      dtTo: '',
      category: '',
      observation: '',
      compensationDate: '',
      allowanceHours: '',

    },
    legendaData: 'Início do periodo',
  };

  componentWillReceiveProps(nextProps) {
    const newInfo = { ...this.state.vacation };
    const employee = nextProps.allowance.filter(employe => (
      employe.id === nextProps.item
    ));
    newInfo.observation = employee && employee[0] && employee[0].observation;
    newInfo.category = employee && employee[0] && employee[0].categoryOriginal;
    newInfo.dtFrom = employee && employee[0] && parse(employee[0].dtFromOriginal, 'yyyy-MM-dd', new Date());
    newInfo.dtTo = employee && employee[0] && parse(employee[0].dtToOriginal, 'yyyy-MM-dd', new Date());
    newInfo.compensationDate = employee && employee[0] && employee[0].compensationDate;
    newInfo.allowanceHours = employee && employee[0] && employee[0].allowanceHours && addMinutes(new Date(0, 0), employee[0].allowanceHours);
    this.setState({ vacation: newInfo });
  }

  getDateAsMinutes = (date) => {
    const hours = getHours(date);
    const minutes = getMinutes(date);
    return (hours * 60) + minutes;
  }

  handleInputChange = (event, type) => {
    const newVacation = { ...this.state.vacation };
    switch (type) {
      case 'category':
        newVacation.category = event.target.value;
        this.setState({ vacation: newVacation });
        break;

      case 'observation':
        newVacation.observation = event.target.value;
        this.setState({ vacation: newVacation });
        break;

      case 'dtFrom':
        newVacation.dtFrom = event;
        this.setState({ vacation: newVacation });
        break;

      case 'dtTo':
        newVacation.dtTo = event;
        this.setState({ vacation: newVacation });
        break;

      case 'compensationDate':
        newVacation.compensationDate = event;
        this.setState({ vacation: newVacation });
        break;

      case 'allowanceHours':
        newVacation.allowanceHours = event;
        this.setState({ vacation: newVacation });
        break;

      default:
        break;
    }
  };

  handleConfirmAction = () => {
    const { vacation } = this.state;

    const {
      onClose, item,
    } = this.props;
    this.props.onUpdateVacations({
      ids: [item],
      category: vacation.category,
      observation: vacation.observation,
      dtFrom: vacation.dtFrom,
      dtTo: vacation.dtTo ? vacation.dtTo : vacation.dtFrom,
      compensationDate: vacation.compensationDate,
      allowanceHours: vacation.allowanceHours && this.getDateAsMinutes(vacation.allowanceHours),
    });
    onClose();
  };


  render() {
    const {
      classes, open, onClose,
    } = this.props;
    const { vacation } = this.state;

    const types = [
      { value: 'VACATION', displayValue: 'FÉRIAS' },
      { value: 'JUST_ABS', displayValue: 'FALTAS JUSTIFICADAS' },
      { value: 'OPTIONAL_DAY', displayValue: 'PONTO FACULTATIVO' },
      { value: 'WORK_LEAVE', displayValue: ' DIA DE FOLGA' },
      { value: 'LEAVE_OF_ABSENCE', displayValue: 'LICENÇA/AFASTAMENTO' },
      { value: 'SUNDAY_OR_HOLIDAY_COMPENSATION', displayValue: 'COMPENSAÇÃO DE DOMINGO/FERIADO' },
      { value: 'ALLOWANCE_HOURS', displayValue: 'ABONO DE HORAS' },
      { value: 'OUT_JUST_ABSENCE', displayValue: 'FALTA SEM JUSTIFICATIVA' },
    ];


    return (
      <React.Fragment>
        <Dialog
          open={open}
          onClose={onClose}
          PaperProps={{ classes: { root: classes.paperWidth } }}
        >
          <React.Fragment>
            <DialogTitle>
              Editar abono
            </DialogTitle>

            <DialogContent>
              <DialogContentText>
                Atualize as informações do abono
              </DialogContentText>
              <div style={{ width: '400px' }}>
                <Input
                  elementType="select"
                  value={vacation.category}
                  onChange={event => this.handleInputChange(event, 'category')}
                  label="Tipo"
                  options={types}
                  margin="normal"
                  required
                  fullWidth
                />
                <Input
                  elementType="input"
                  value={this.state.vacation.observation}
                  onChange={event => this.handleInputChange(event, 'observation')}
                  label="Observação"
                  margin="normal"
                  required
                  fullWidth
                />
              </div>
              <>
                {this.state.vacation.category === 'SUNDAY_OR_HOLIDAY_COMPENSATION'
                  ? <div className="picker">
                    <Input
                      elementType="datePicker"
                      style={{ marginRight: '40px' }}
                      label="Dia de folga"
                      margin="normal"
                      value={vacation.dtFrom}
                      onChange={event => this.handleInputChange(event, 'dtFrom')}
                    />
                    <Input
                      elementType="datePicker"
                      label="Domingo/feriado trabalhado"
                      margin="normal"
                      value={vacation.compensationDate}
                      onChange={event => this.handleInputChange(event, 'compensationDate')}
                    />
                  </div>
                  : this.state.vacation.category === 'ALLOWANCE_HOURS' ? <div className="picker">
                    <Input
                      elementType="datePicker"
                      label="Dia"
                      style={{ marginRight: '40px' }}
                      margin="normal"
                      value={vacation.dtFrom}
                      onChange={event => this.handleInputChange(event, 'dtFrom')}
                    />
                    <Input
                      elementType="timePicker"
                      style={{ marginRight: '40px' }}
                      label="Horas abonadas"
                      margin="normal"
                      value={vacation.allowanceHours}
                      onChange={event => this.handleInputChange(event, 'allowanceHours')}
                    />
                  </div> : <div className="picker" > <Input
                    elementType="datePicker"
                    style={{ marginRight: '40px' }}
                    label={this.state.legendaData}
                    margin="normal"
                    value={this.state.vacation.dtFrom}
                    onChange={event => this.handleInputChange(event, 'dtFrom')}
                  />
                    <Input
                      elementType="datePicker"
                      label="Fim do período"
                      margin="normal"
                      value={this.state.vacation.dtTo}
                      minDate={this.state.vacation.dtFrom}
                      onChange={event => this.handleInputChange(event, 'dtTo')}
                    />
                  </div>}
              </>

            </DialogContent>

            <DialogActions>
              <Button onClick={onClose}>CANCELAR</Button>
              <Button
                type="submit"
                variant="raised"
                color="primary"
                onClick={this.handleConfirmAction}
              >
                CONFIRMAR
              </Button>
            </DialogActions>
          </React.Fragment>
        </Dialog>
      </React.Fragment>
    );
  }
}

AllowanceEditDialog.propTypes = {
  employees: PropTypes.array,
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onCreateVacations: PropTypes.func.isRequired,
  onUpdateVacations: PropTypes.func.isRequired,
};

AllowanceEditDialog.defaultProps = {
  open: false,
  employees: undefined,
};

const mapStateToProps = state => ({
  loading: state.general.loading,
});

const mapDispatchToProps = dispatch => ({
  onCreateVacations: vacation => dispatch(createVacations(vacation)),
  onUpdateVacations: vacation => dispatch(updateVacations(vacation)),
});

export const StyledComponent = withStyles(styles)(AllowanceEditDialog);

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(StyledComponent));
